// 🆕 src/legal/index.ts
// Централизованный экспорт всех юридических документов

import ofertaText from './oferta.md?raw';
import privacyText from './privacy-policy.md?raw';
import consentPdText from './consent-pd.md?raw';
import consentNewsletterText from './consent-newsletter.md?raw';
import cookiesText from './cookies.md?raw';

// ⚠️ Менять при ЛЮБОМ существенном изменении текстов: смена версии заставляет
// всех пользователей принять документы заново (см. useLegalAcceptance).
// 2026-08-17 — перенос обработки данных в РФ, изменён состав обработчиков,
// добавлен раздел о cookie и локальном хранилище.
// 2026-08-29 — превью блюд по выбору пользователя: появилась категория данных,
// которой раньше не было вовсе («фото не сохраняются»). Согласие заново.
// 2026-09-04 — изменена цена промо-месяца (550 → 990 ₽). Цена в оферте —
// материальное условие публичного договора, поэтому редакция новая, хотя
// для действующих пользователей условия не поменялись: промо касается только
// новых, и им за всё время воспользовались двое.
// 2026-09-22: точный перечень сведений, которые уходят AI-сервисам (раньше п. 4.3 согласия
// утверждал, что дневник и вес за границу не передаются, — а в запросе к ИИ они были);
// резервный канал через AI Gateway ООО «ТАЙМВЭБ.КЛАУД»; тесты и привычки в перечне данных;
// соглашение о простой электронной подписи в оферте (письменная форма согласия на данные о здоровье);
// точное юрлицо хостинга; копия у Supabase — в США, а не в Германии.
// 2026-10-11: в оферте появился новый платный товар — пакеты дополнительных сообщений
// AI-помощнику (п. 4.4.6) и порядок возврата за неизрасходованные (п. 5.5).
// Цена и условия возврата — материальные условия договора, редакция новая.
export const LEGAL_DOCUMENT_VERSION = '2026-10-11';

export type LegalDocKey = 'oferta' | 'privacy' | 'consent-pd' | 'consent-newsletter' | 'cookies';

export interface LegalDocument {
  key: LegalDocKey;
  title: string;
  shortTitle: string;
  description: string;
  content: string;
}

export const LEGAL_DOCUMENTS: Record<LegalDocKey, LegalDocument> = {
  'oferta': {
    key: 'oferta',
    title: 'Публичная оферта',
    shortTitle: 'Оферта',
    description: 'Условия использования сервиса и оказания услуг',
    content: ofertaText,
  },
  'privacy': {
    key: 'privacy',
    title: 'Политика конфиденциальности',
    shortTitle: 'Политика конфиденциальности',
    description: 'Как мы обрабатываем твои данные',
    content: privacyText,
  },
  'consent-pd': {
    key: 'consent-pd',
    title: 'Согласие на обработку персональных данных',
    shortTitle: 'Согласие на обработку данных',
    description: 'Включая данные о состоянии здоровья',
    content: consentPdText,
  },
  'consent-newsletter': {
    key: 'consent-newsletter',
    title: 'Согласие на рассылки',
    shortTitle: 'Рассылки',
    description: 'Push, email, новости сервиса',
    content: consentNewsletterText,
  },
  'cookies': {
    key: 'cookies',
    title: 'Файлы cookie и локальное хранилище',
    shortTitle: 'Cookie',
    description: 'Что сохраняется в браузере и зачем',
    content: cookiesText,
  },
};

// Список документов в порядке отображения в Профиле
export const LEGAL_DOCS_LIST: LegalDocument[] = [
  LEGAL_DOCUMENTS['oferta'],
  LEGAL_DOCUMENTS['privacy'],
  LEGAL_DOCUMENTS['consent-pd'],
  LEGAL_DOCUMENTS['consent-newsletter'],
  LEGAL_DOCUMENTS['cookies'],
];

// Документы которые юзер ОБЯЗАН принять при онбординге
export const REQUIRED_FOR_ACCEPTANCE: LegalDocKey[] = ['oferta', 'privacy', 'consent-pd'];
